import uploadsscholarshipssidebyside02imageshutterstock_278796914Jpg from "$lib/data/generated/uploads/scholarships/SideBySide 02/image/shutterstock_278796914.jpg?as=run";

export const uploads = {
  "uploads/scholarships/SideBySide 02/image/shutterstock_278796914.jpg": uploadsscholarshipssidebyside02imageshutterstock_278796914Jpg
};